import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common';
import {getCookie, showToast, getFetchError, getCatchError} from '../app_common.js';

export const getApiLogQueryRangeArray = async(arrData) => {
    if( !checkPermission('getApiLogQueryRange', PERMISSION_MONITORING) )
    { 
        return null;
    }

    const responses = [];
    let fail = false;
    
    for( const item of arrData )
    {
        // console.log('요청', item);
        try {
            const response = await fetchWithTimeout(`/api/log/query/range?direction=${item.direction}&limit=${item.limit}&query=${item.query}&start=${item.start}&end=${item.end}&step=${item.step}`, {
                timeout: TIMEOUT,
                method: 'GET',
                headers: {
                    "accept": "application/json",
                    "Authorization": "Bearer " + getCookie('accessToken')
                }
            });

            try {
                const json = await response.json();
                getFetchError(response, json, false);
                responses.push(json);
                // console.log('응답');
            } catch (e) {
                getFetchError(response, null, false);
                fail = true;
                break;
            }
        } catch (err) {
            getCatchError(err);
            return null;
        };
    }

    if( fail )
    {
        return null;
    }
    else
    {
        return responses;
    }
}

export const getApiLogQueryRange = async(direction, limit, query, start, end, step) => {
    if( !checkPermission('getApiLogQueryRange', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/log/query/range?direction=${direction}&limit=${limit}&query=${query}&start=${start}&end=${end}&step=${step}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiLogQuery = async(direction, query, limit, utc_time) => {
    if( !checkPermission('getApiLogQuery', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/log/query?direction=${direction}&query=${query}&limit=${limit}&utc_time=${utc_time}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiLogLabels = async() => {
    if( !checkPermission('getApiLogLabels', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/log/labels`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiLogValues = async(label) => {
    if( !checkPermission('getApiLogValues', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/log/values?label=${label}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            }
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}